import React from "react";
import { CATEGORY_CONFIG } from "../../constant/offerFormConfig";
import OfferMediaUploader from "./offerMedia/OfferMediaUploader";

const CreateOfferDetailsComp = ({
	form,
	handleChange,
	shopDetails,
	setShowAiPopup,
	setAiTriggered,
	offerMedia,
	setOfferMedia,
}) => {
	const config = CATEGORY_CONFIG[shopDetails.category];
	return (
		<div className="card-box">
			<div className="row mt-2">
				<div className="col-12">
					<div className="d-flex justify-content-between">
						<label className="mb-0">Category</label>
					</div>
					<input
						type="text"
						name="category"
						value={shopDetails.category}
						className="form-control custom-input"
					/>
				</div>

				{/* DYNAMIC FIELDS */}
				<div className="col-12 mt-3">
					{config?.subCategory && (
						<select
							name="subCategoryType"
							className="form-control custom-input"
							onChange={handleChange}
						>
							<option>Select sub category</option>
							{config?.subCategory.map((i) => (
								<option key={i}>{i}</option>
							))}
						</select>
					)}
				</div>

				<div className="col-12 my-3">
					<select
						name="offerType"
						className="form-control custom-input"
						onChange={handleChange}
					>
						<option>Percent</option>
						<option>Flat</option>
						<option>Buy 1 Get 1</option>
						<option>Buy 2 Get 1</option>
						<option>COMBO</option>
					</select>
				</div>
			</div>

			{(form.offerType === "Percent" || form.offerType === "Flat") && (
				<input
					name="offerValue"
					value={form?.offerValue}
					type="number"
					onChange={handleChange}
					className="form-control custom-input mt-2"
					placeholder={`${form?.offerType === "Percent" ? "%" : "Discount Value"}`}
				/>
			)}

			{/* <div
				className="select-offer-image py-2 mt-3"
				onClick={() => {
					setShowAiPopup(true);
					setAiTriggered(true);
				}}
			>
				<button className="px-3 py-1 w-75">Choose offer image</button>
			</div> */}

			<div className="d-flex justify-content-between pt-3">
				<label className="mb-0">Offer title</label>
			</div>
			<input
				name="title"
				value={form?.title}
				onChange={handleChange}
				className="form-control custom-input"
				placeholder="Offer title"
			/>
			<div className="d-flex justify-content-between pt-3">
				<label className="mb-0">Offer short details</label>
			</div>
			<input
				name="description"
				value={form?.description}
				onChange={handleChange}
				className="form-control text-area-input mb-3"
				placeholder="Offer details"
			/>

			<div className="d-flex justify-content-between">
				<label className="mb-0">Offer more details</label>
			</div>
			<textarea
				name="offerLongDetails"
				value={form?.offerLongDetails}
				onChange={handleChange}
				className="form-control text-area-input mb-3"
				rows="3"
				placeholder="Offer more details"
			/>
			<div className="d-flex justify-content-between">
				<label className="mb-0">Instagram link</label>
			</div>
			<input
				name="instagramLink"
				value={form?.instagramLink}
				onChange={handleChange}
				className="form-control text-area-input mb-3"
				placeholder="Your instagram link"
			/>

			{/* sample image and video selected component */}
			<OfferMediaUploader media={offerMedia} setMedia={setOfferMedia} />
		</div>
	);
};

export default CreateOfferDetailsComp;
